'use client';
import CategoryTabSkeleton from '@/src/ui/skeletons/CategoryTabSkeleton';
import { useGetAllCategoriesDataQuery } from '@/src/store/rtkQueries/userGetAPI';
import { Button } from '@heroui/react';
import { useRouter, usePathname, useSearchParams } from 'next/navigation';
import React from 'react';

export default function CategoryTab({ category, sub_category }: { category: string, sub_category: string }) {
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const isSubCategoryView = Boolean(category);
    const { data: categoriesData, isLoading } = useGetAllCategoriesDataQuery({ category });
    const active = isSubCategoryView ? sub_category : category;

    const data = categoriesData?.data;
    const CATEGORIES = !data
        ? []
        : Array.isArray(data)
            ? data
            : data.sub_categories ?? [];

    const handleSelect = (slug: string) => {
        const params = new URLSearchParams(searchParams.toString());

        if (isSubCategoryView) {
            if (slug) {
                params.set('sub_category', slug);
            } else {
                params.delete('sub_category');
            }
        } else {
            if (slug) {
                params.set('category', slug);
            } else {
                params.delete('category');
            }
            params.delete('sub_category');
        }

        router.replace(`${pathname}${params.toString() ? `?${params.toString()}` : ''}`, { scroll: false });
    };

    const allLabel =
        isSubCategoryView && data && !Array.isArray(data) ? data.name : 'All';

    const chipBase =
        'global_btn shrink-0 whitespace-nowrap min-w-fit! rounded_full h-10 px-4 text-xs sm:text-sm'

    return (
        <div className="py-4" role="tablist" aria-label="Product categories">
            {/* Mobile: single-row horizontal scroll; md+: wrap */}
            <div className="flex flex-nowrap md:flex-wrap gap-2 overflow-x-auto overflow-y-hidden overscroll-x-contain custom_scrollbar md:pe-0 md:overflow-visible [-webkit-overflow-scrolling:touch] pb-2 md:pb-0">
                <Button
                    className={`${chipBase} ${active === '' ? 'bg_primary' : 'outline_primary'}`}
                    onPress={() => handleSelect('')}
                >
                    {allLabel}
                </Button>
                {isLoading ? (
                    <CategoryTabSkeleton count={6} />
                ) : (
                    CATEGORIES?.length > 0 &&
                    CATEGORIES.map((item) => (
                        <Button
                            key={item._id}
                            className={`${chipBase} ${active === item.slug ? 'bg_primary' : 'outline_primary'}`}
                            onPress={() => handleSelect(item.slug)}
                        >
                            {item.name}
                        </Button>
                    ))
                )}
            </div>
        </div>
    );
}
